import {act, render} from '@testing-library/react/pure';
import {QueryClient, QueryClientProvider} from 'react-query';
import VolumeDiscountMessage from '.';

describe('VolumeDiscount', () => {
  const mockColor = {legacyColorId: 1};
  const mockDiscountPercentage = 4;
  const mockCanOrderSingles = true;

  test('renders the correct volume discount message', async () => {
    const queryClient = new QueryClient();

    let findAllByText;
    await act(async () => {
      ({findAllByText} = render(
        <QueryClientProvider client={queryClient}>
          <VolumeDiscountMessage
            currentColor={mockColor}
            discountPercentage={mockDiscountPercentage}
            canOrderSingles={mockCanOrderSingles}
          />
        </QueryClientProvider>
      ));
    });

    const elements = await findAllByText((content, node) => {
      const hasText = (nodes) =>
        nodes.textContent === '$ each' ||
        nodes.textContent === 'Saving 4%' ||
        nodes.textContent === 'with volume discount.';
      const nodeHasText = hasText(node);
      const childrenDontHaveText = Array.from(node.children).every(
        (child) => !hasText(child)
      );

      return nodeHasText && childrenDontHaveText;
    });

    expect(elements[0].textContent).toEqual('$ each');
    expect(elements[1].textContent).toEqual('Saving 4%');
    expect(elements[2].textContent).toEqual('with volume discount.');
  });
});
